module.exports = __webpack_public_path__ + "static/yoggie-a9a97209cc238c6700d5ed5f0cde8d9e.png";